import z from 'zod'

export const ShiftOfferStatus = z.enum(['pending', 'accepted', 'applied', 'rejected', 'declined', 'queued'])
export type ShiftOfferStatus = z.infer<typeof ShiftOfferStatus>
